//Category status
export const READY_TO_EDIT = 'READY TO EDIT';
export const IN_PROGRESS = 'IN PROGRESS';
export const SUBMITTED_FOR_REVIEW = 'SUBMITTED FOR REVIEW';
export const PUBLISHED = 'PUBLISHED';

//Module status
export const UNMODIFIED = 'Unmodified';
export const MODIFIED = 'Modified';

//Question Tags CDS|PROFILE|AUTO_PUBLISH|REVIEW
export const PROFILE = 'PROFILE';
export const CDS = 'CDS';
export const AUTO_PUBLISH = 'AUTO_PUBLISH';
export const REVIEW = 'REVIEW';
export const MEDIA_UPLOAD = 'MEDIA_UPLOAD';
export const ADMIN = 'ADMIN';

//Save Status
export const LOAD = 'load';
export const SAVE_IN_PROGRESS = 'saveInProgress';
export const SAVE_SUCCESS = 'saveSuccess';
export const SAVE_ERROR = 'saveError';
export const FINISH_SUCCESS = 'finishSuccess';
export const FINISH_ERROR = 'finishError';
export const SAVE_SUCCESS_CDS = 'saveSuccessCds';
export const SAVE_IN_PROGRESS_CDS = 'saveInProgressCds';
export const SAVE_ERROR_CDS = 'saveErrorCds';